// grab your elements exactly once
const productsOnPage   = document.getElementById('product-grid');
let   nextUrl          = productsOnPage.dataset.nextUrl;
const loadMoreBtn      = document.querySelector('.load-more_btn');
const loadMoreSpinner  = document.querySelector('.load-more_spinner');

// for prefetching
let prefetchedPage = null;

// start fetching page 2 in the background
async function prefetchNext() {
  if (!nextUrl) return;
  prefetchedPage = fetch(nextUrl).then(r => r.text());
}
prefetchNext();

async function loadMoreProducts() {
  // hide button, show spinner
  loadMoreBtn.style.display     = 'none';
  loadMoreSpinner.style.display = 'block';

  // use prefetched data if available, otherwise fetch
  const htmlText = await (prefetchedPage || fetch(nextUrl).then(r => r.text()));

  // immediately kick off prefetch for the next page
  const doc       = new DOMParser().parseFromString(htmlText, 'text/html');
  const nextGrid  = doc.getElementById('product-grid');
  nextUrl         = nextGrid.dataset.nextUrl;
  prefetchedPage  = null;
  prefetchNext();

  // grab & append items with animation classes
  const newItems = doc.querySelectorAll('#product-grid .grid__item');
  newItems.forEach(item => {
    item.classList.add('newly-added');
    productsOnPage.appendChild(item);
    setTimeout(() => item.classList.add('visible'), 50);
  });

  // toggle spinner/button
  loadMoreSpinner.style.display = 'none';
  if (nextUrl) loadMoreBtn.style.display = 'flex';
}

// expose to global so your inline onclick works
window.loadMoreProducts = loadMoreProducts;
